import {
  FormRichTextEditor,
  type FormRichTextEditorProps,
} from '@exam-management/rich-text-editor';
import { type FieldValues } from 'react-hook-form';

import { useUploadImageForQuestion } from '../../hooks';

export interface SolutionFieldProps<TFieldValues extends FieldValues>
  extends Pick<FormRichTextEditorProps<TFieldValues>, 'name' | 'required'> {
  questionId?: string;
}

export default function SolutionField<TFieldValues extends FieldValues>(
  props: Readonly<SolutionFieldProps<TFieldValues>>,
) {
  const { name, questionId, required: isRequired } = props;

  const { handleUpload, loading: isLoading } = useUploadImageForQuestion({
    questionId,
  });

  return (
    <FormRichTextEditor
      label='คำอธิบายเฉลย'
      onImageUpload={handleUpload}
      loading={isLoading}
      name={name}
      placeholder='กรอกคำอธิบายเฉลย'
      required={isRequired}
    />
  );
}
